import { render, staticRenderFns } from "./StockThresholdPanel.vue?vue&type=template&id=3d22bacf&scoped=true&"
import script from "./StockThresholdPanel.vue?vue&type=script&lang=js&"
export * from "./StockThresholdPanel.vue?vue&type=script&lang=js&"
import style0 from "./StockThresholdPanel.vue?vue&type=style&index=0&id=3d22bacf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22bacf",
  null
  
)

export default component.exports